import { render, staticRenderFns } from "./CdBadge.vue?vue&type=template&id=49f6eda8&"
import script from "./CdBadge.vue?vue&type=script&lang=js&"
export * from "./CdBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3744633428/src/vbc-messaging-10-dlc-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49f6eda8')) {
      api.createRecord('49f6eda8', component.options)
    } else {
      api.reload('49f6eda8', component.options)
    }
    module.hot.accept("./CdBadge.vue?vue&type=template&id=49f6eda8&", function () {
      api.rerender('49f6eda8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/atomicUIComponents/badge/CdBadge.vue"
export default component.exports